export default __webpack_public_path__ + "static/media/PO@3x.2f2f3509.png";